import React, { useEffect, useState } from "react";
import YouTube from "react-youtube";
import movieTrailer from "movie-trailer";
import "./Row.css";
import axios from "../axios";
function Row({ title, fetchUrl, isLargeRow }) {
  const img_base_url = "https://image.tmdb.org/t/p/original";
  const [movies, setMovies] = useState([]);
  const [videoId, setVideoId] = useState("");
  useEffect(() => {
    async function fetchData() {
      const request = await axios.get(fetchUrl);
      //   console.log(request);
      setMovies(request.data.results);
      // console.log(movies);
    }
    fetchData();
  }, [fetchUrl]);
  const opts = {
    height: "390",
    width: "100%",
    playerVars: { autoplay: 1 },
  };
  const handleClick = (movie) => {
    if (videoId) {
      setVideoId("");
    } else {
      movieTrailer(movie?.title || movie?.name || movie?.original_name)
        .then((url) => {
          const urlParams = new URLSearchParams(new URL(url).search);
          setVideoId(urlParams.get("v"));
        })
        .catch((error) => console.log(error));
    }
  };
  return (
    <div className="row">
      <h2 className="row_title">{title}</h2>
      <div className="row_posters">
        {movies?.map((movie) => {
          const { id, poster_path, backdrop_path, original_title } = movie;
          return (
            <img
            key={id}
              onClick={() => {
                handleClick(movie);
              }}
              className={`row_poster ${isLargeRow && "row_posterLarge"}`}
              src={`${img_base_url}${isLargeRow ? poster_path : backdrop_path}`}
              alt={`${original_title}`}
            />
          );
        })}
      </div>
      <div style={{ padding: "5px" }}>
        {videoId && <YouTube videoId={videoId} opts={opts} />}
      </div>
    </div>
  );
}
export default Row;
